import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Filter } from 'lucide-react';
import { loadPosts } from './utils/loadPosts';
import './Blog.css';

const Blog = () => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeFilter, setActiveFilter] = useState('All');

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      const posts = await loadPosts();
      setArticles(posts);
      setLoading(false);
    };
    fetchPosts();
  }, []);

  const handleReadMore = (articleId) => {
    navigate(`/blog/article/${articleId}`);
  };

  const categories = ['All', ...new Set(articles.map(a => a.category).filter(Boolean))];

  const normalize = (str) => (str || '').toLowerCase().trim();

  const filteredArticles = articles
    .filter(a => activeFilter === 'All' || normalize(a.category) === normalize(activeFilter))
    .sort((a, b) => new Date(b.date) - new Date(a.date));

  return (
    <div className="blog">
      <div className="blog-container">

        {/* HEADER */}
        <div className="blog-hero">
          <h1 className="blog-title">Blog</h1>
          <p className="blog-subtitle">
            Musings on a variety of topics from faith to finances
          </p>
        </div>

        {/* FILTER BAR */}
        <div className="blog-filter-bar">
          <div className="blog-filter-label">
            <Filter size={15} strokeWidth={2} />
            <span>Filter</span>
          </div>

          <div className="blog-filter-options">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`blog-filter-btn ${activeFilter === cat ? 'active' : ''}`}
                onClick={() => setActiveFilter(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* ARTICLES */}
        <div className="blog-content">
          {loading ? (
            <div className="blog-loading">
              <div className="blog-spinner" />
              <p>Loading posts...</p>
            </div>
          ) : (
            <>
              <p className="blog-results-count">
                {filteredArticles.length} {filteredArticles.length === 1 ? 'post' : 'posts'}
                {activeFilter !== 'All' && (
                  <>
                    {' '}in <strong>{activeFilter}</strong>
                  </>
                )}
              </p>

              <div className="blog-articles-list">
                {filteredArticles.map((article) => (
                  <div
                    key={article.id}
                    className="blog-card"
                    onClick={() => handleReadMore(article.id)}
                  >
                    <div className="blog-card-top">
                      <span className="blog-card-category">{article.category}</span>
                      <span className="blog-card-read-time">{article.readTime}</span>
                    </div>

                    <h3 className="blog-card-title">{article.title}</h3>
                    <p className="blog-card-excerpt">{article.excerpt}</p>

                    <div className="blog-card-bottom">
                      <span className="blog-card-date">{article.date}</span>
                      <span className="blog-card-link">
                        Read More →
                      </span>
                    </div>
                  </div>
                ))}

                {filteredArticles.length === 0 && (
                  <div className="blog-empty">
                    <p>No posts yet in this category.</p>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;